module.exports = __webpack_public_path__ + "img/lunbo51.52999dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo51.png
// module id = W+HG
// module chunks = 0